import { BTSection } from "@btnet/core-components/BTSection";
import { BTText } from "@btnet/core-components/BTText";

import { BdsButton, BdsIconXCircle } from "@buildertrend/components";

interface IAccountingLinkingCardFailedProps {
    onReloadAccounting: () => Promise<void>;
}

export const AccountingLinkingCardFailed: React.FunctionComponent<
    IAccountingLinkingCardFailedProps
> = ({ onReloadAccounting }) => {
    return (
        <BTSection data-testid="accountingLinkingCard" className="AccountingLinkingCard">
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsIconXCircle size="xl" />
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BTText size="heavy-sm">Failed to load accounting data</BTText>
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BTText size="normal-md">Please try refreshing your page.</BTText>
                </div>
            </div>
            <div className="flex flex-row">
                <div className="flex flex-col grow failed-content">
                    <BdsButton
                        displayType="secondary"
                        text="Try again"
                        id="retryAccounting"
                        onClick={async () => {
                            await onReloadAccounting();
                        }}
                        testid="retryAccounting"
                    />
                </div>
            </div>
        </BTSection>
    );
};
